import gql from "graphql-tag";

export default gql`
mutation DeleteAgreementDocument($deleteAgreementDocumentId: ID!) {
    deleteAgreementDocument(id: $deleteAgreementDocumentId)
  }
`;
